import { Typography } from '@neo4j-ndl/react';
import { ArrowLeftIconOutline } from '@neo4j-ndl/react/icons';
import { Link } from 'react-router';

type PageTitleProps = {
  title: string;
  titleProps?: React.ComponentProps<typeof Typography>;
  trailingContent?: React.ReactNode;
  back?: {
    label: string;
    onClick?: () => void;
    toUrl: string;
  };
};

export const PageTitle = ({ title, trailingContent, back, titleProps }: PageTitleProps) => {
  return (
    <div className="flex flex-col">
      {back !== undefined && (
        <Link to={back.toUrl} onClick={back.onClick} className="mb-4 flex w-fit flex-row items-center gap-3">
          <ArrowLeftIconOutline className="size-4 flex-shrink-0" />
          <Typography variant="body-medium" className="font-bold">
            {back.label}
          </Typography>
        </Link>
      )}

      <div className="flex flex-row items-center gap-2">
        <Typography variant="h4" {...titleProps}>
          {title}
        </Typography>
        {trailingContent !== undefined && <div className="ml-auto flex flex-row gap-2">{trailingContent}</div>}
      </div>
    </div>
  );
};
